import { signOut } from 'aws-amplify/auth';
import { useNavigate } from 'react-router-dom';
import { PageLayout, Button, StatusPageHeader } from '@/components';
import { ROUTES } from '../routes.ts';
import styles from './SuspendedAccount.module.css';

export function SuspendedAccount() {
  const navigate = useNavigate();

  async function handleSignOut() {
    await signOut();
    navigate(ROUTES.login, { replace: true });
  }

  return (
    <PageLayout plain centerText>
      <StatusPageHeader />

      <p className={styles.heading}>Je account is geblokkeerd</p>
      <p className={`text-muted ${styles.body}`}>
        Je hebt momenteel geen toegang tot Dermalink. Neem contact op met de beheerders via{' '}
        <a href="mailto:info@dermalink.be">info@dermalink.be</a>.
      </p>

      <Button variant="primary" onClick={handleSignOut} className={styles.button}>
        Terug naar aanmelden
      </Button>
    </PageLayout>
  );
}
